import React, { useState } from 'react';
import { Image } from 'react-bootstrap';

export interface AvatarProps {
  width: number | string;
  height: number | string;
  src?: string;
  fallback?: React.ReactNode;
}

const Avatar: React.FC<AvatarProps> = ({ width, height, src, fallback }) => {
  const [imgError, setImgError] = useState<boolean>(false);

  return (
    <div className="wrapper-avatar" style={{ width: width, height: height }}>
      {src && !imgError && (
        <Image
          src={src}
          className="avatar"
          onError={() => {
            setImgError(true);
          }}
          style={{ width: width, height: height }}
          roundedCircle
        />
      )}
      {!src && fallback}
      {(!src || imgError) && !fallback && (
        <span className="avatar mdi mdi-account-circle" style={{ fontSize: width }}></span>
      )}
    </div>
  );
};

export default Avatar;
